import { useEffect } from 'react'

import type {
  TemplateVersion,
  TemplateVersionInfo,
} from '../types/templateModel'
import { useTemplateVersion } from '../uiModels/useTemplateVersion'

type Props = {
  versionInfo: TemplateVersionInfo
  onRegisterActiveVersion: (activeVersionInHierarchy: TemplateVersion) => void
}

/**
 * Component responsible for registering an inherited template version in the TemplateProvider.
 * These registered versions are used for diffing purposes.
 */
export const InheritedTemplateVersionRegistrator = ({
  versionInfo,
  onRegisterActiveVersion,
}: Props) => {
  const templateVersionForDate = useTemplateVersion({
    versionInfo,
    // These versions are generated for diffing purposes. Initially we only diff against non-flattened templates.
    isFlattened: false,
  })

  useEffect(
    function registerActiveTemplateVersion() {
      if (templateVersionForDate) {
        onRegisterActiveVersion(templateVersionForDate)
      }
    },
    [onRegisterActiveVersion, templateVersionForDate],
  )

  return null
}
